import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { useLocation } from "react-router-dom";
import showToast from "../../../services/toast";
import { AlertLoadingHeader } from "../../../components/alertLoadingComponent/alertLoading";
import PagesHeader from "ah_utility/PagesHeader";
import { useStepNavigation } from "ah_utility/NavigationEngine";
export var PassengerFormHeader = function (props) {
    var pathname = useLocation().pathname;
    var isLastPage = useStepNavigation({ currentStepId: pathname }).isLastPage;
    return (_jsxs(_Fragment, { children: [_jsx(AlertLoadingHeader, { loading: props.loading, seeToast: props.seeToast, showToast: showToast, setSeeToast: props.setSeeToast, titleLoading: "Cargando..." }), _jsx(PagesHeader, { titlePage: "Agregar Pasajero", hideStep: true, steps: props.steps, completed: isLastPage })] }));
};
